import { createAnalyticsCardBaseProps } from '../pages/AnalyticsDashboard/utils/createAnalyticsCardBaseProps';
import { useAnalyticsReportBase } from './useAnalyticsReportBase';
export const useAnalyticsCardBase = ({ reportId, filters }) => {
    const reportBase = useAnalyticsReportBase({ reportId, filters });
    const analyticsCardBaseProps = createAnalyticsCardBaseProps(reportBase);
    return {
        ...analyticsCardBaseProps,
        enabled: !!reportBase.reportDefinition,
        reportData: reportBase.reportData,
        reportDefinition: reportBase.reportDefinition,
        activeColumn: reportBase.activeColumn,
    };
};
